import { Modal } from 'antd';

// Storage and broadcast purchases are switched off for now; flip this to reopen them.
export const PURCHASES_PAUSED = true;

const PAUSED_MESSAGES = {
    storage: {
        title: 'Storage purchase unavailable',
        content: 'Storage purchase is temporarily unavailable. Please contact aulas support for help.',
    },
    broadcast: {
        title: 'Broadcast purchase unavailable',
        content: 'Broadcast purchase is temporarily unavailable. Please contact aulas support for help.',
    },
};

// Popup shown in place of the payment flow while purchases are paused; type is 'storage' or 'broadcast'.
export const showPurchasesPausedPopup = (type) => {
    const message = PAUSED_MESSAGES[type] || PAUSED_MESSAGES.storage;
    Modal.info({
        title: message.title,
        content: message.content,
        okText: 'OK',
        centered: true,
    });
};
